import type { ApiFetch } from '../../api/client';
import { readErrorMessage, readJson } from '../../api/client';
import type { PatientTrackingDashboardSummary } from './patientTrackingDashboardTypes';

export async function fetchPatientTrackingDashboardSummary(
  apiFetch: ApiFetch,
  basePath = '/api/patient-tracking/dashboard'
): Promise<PatientTrackingDashboardSummary> {
  const res = await apiFetch(`${basePath}/summary`);
  if (!res.ok) throw new Error(await readErrorMessage(res));
  return readJson<PatientTrackingDashboardSummary>(res);
}
